var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lk-burger-btn",class:{ 'lk-burger-btn--open': _vm.value },attrs:{"type":"button","aria-expanded":_vm.value ? 'true' : 'false'},on:{"click":_vm.toggle}},[_c('span',{staticClass:"lk-burger-btn__line lk-burger-btn__line--top"}),_vm._v(" "),_c('span',{staticClass:"lk-burger-btn__line lk-burger-btn__line--middle"}),_vm._v(" "),_c('span',{staticClass:"lk-burger-btn__line lk-burger-btn__line--bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/lk/header/components/LkBurgerBtn.vue?vue&type=template&id=21e2389c&
// module id = 1595
// module chunks = 0